import { CommonService } from '../common.service';
import { ApiService } from '../api.service';
import { ActivatedRoute, Router } from '@angular/router';
import { AbilityConfig } from '../ability-config/ability-config';
import { PlatformLocation } from '@angular/common';
import { TokenService } from '../tokenService.service';
var CasePracticeMaxReportComponent = (function () {
    function CasePracticeMaxReportComponent(commonService, apiService, route, platformLocation, tokenService, router) {
        this.commonService = commonService;
        this.apiService = apiService;
        this.route = route;
        this.platformLocation = platformLocation;
        this.tokenService = tokenService;
        this.router = router;
        // 是否显示等级组件：用于异步渲染判断
        this.isShowReportLv = false;
        this.reportName = '达至最佳绩效';
        this.assetsRoute = '../../assets';
        this.itemClickEnable = false;
        this.isOpenClass = 0;
    }
    CasePracticeMaxReportComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.assetsRoute = this.commonService.setAssetsRoute(this.assetsRoute);
        this.abilityConfig = new AbilityConfig(this.apiService, this.commonService);
        this.bestPathBoxShow = false;
        this.analysisBoxShow = false;
        this.starShow = false;
        this.pathClickable = true;
        this.goToListClickedStatus = false;
        this.redoClickedStatus = false;
        this.route.queryParams.subscribe(function (queryParams) {
            _this.type = queryParams['type'];
        });
        this.route.params.subscribe(function (params) {
            _this.cardId = params['cardId'];
            _this.exerciseMetaId = params['exerciseMetaId'];
            var isOutLink = Number(params['isOutLink']);
            _this.practiceMetaId = { 60602: 606, 60603: 606 }[_this.exerciseMetaId];
            _this.skinColor = { 60602: 'Max', 60603: 'Max3' }[_this.exerciseMetaId];
            if (_this.platformLocation['location']['href'].indexOf('isShowBack') > -1 || isOutLink === 1) {
                localStorage.setItem('openClass', '1');
            }
            else {
                localStorage.removeItem('openClass');
            }
            _this.isOpenClass = Number(localStorage.getItem("openClass")) ? 1 : 0;
            _this.getLearningTour().then(function (result) {
                _this.userId = result.user_id;
            }).then(function () {
                return _this.createAndGetPracticeList(_this.exerciseMetaId, _this.userId).then(function (result) {
                    return _this.practiceList = result;
                });
            }).then(function () {
                return _this.getLearningPathMetaId(_this.practiceList.learningPathId).then(function (result) {
                    return _this.learningPathMetaId = result.data;
                });
            }).then(function () {
                return _this.getExerciseTutor(_this.exerciseMetaId).then(function (result) {
                    return _this.exerciseTutor = result;
                });
            }).then(function () {
                return _this.getKAStar(_this.cardId).then(function (result) {
                    return _this.userKA = result;
                });
            }).then(function () {
                return _this.getKAAnalysis(_this.exerciseMetaId).then(function (result) {
                    return _this.KaAnalysis = result;
                });
            }).then(function () {
                $('#userIdContainer').val(_this.userId);
                $('#learningPathMetaIdContainer').val(_this.learningPathMetaId);
                _this.report = _this.handleKaReport(_this.userKA, _this.KaAnalysis);
                _this.mode = 4;
                _this.starPicUrl = '/casepracticeperformance/';
                _this.starPicUrl += { 60602: 'star_report2.png', 60603: 'star_report3.png' }[_this.exerciseMetaId];
                _this.tutor = _this.exerciseTutor.tutor;
                _this.optimum = _this.exerciseTutor.optimum;
                _this.reportKAData = _this.setPracticeLevelDictionary(_this.userKA);
                _this.lvCls = _this.reportKAData ? _this.lvCls = _this.mode + ' bgBlur' : _this.lvCls = _this.mode + '';
                _this.isShowReportLv = _this.lvCls.indexOf('bgBlur') === -1 ? false : true;
                setTimeout(function () {
                    _this.itemClickEnable = true;
                }, 500);
            });
        });
    };
    CasePracticeMaxReportComponent.prototype.ngAfterViewInit = function () {
        var that = this;
        this.commonService.initPage({
            'backgroundColor': 'white'
        });
        $(document).ready(function () {
            var listenerTimeout = setInterval(function () {
                var bestPathEle = document.getElementById('bestPathBox'), analysisEle = document.getElementById('analysisContent'), tutorEle = document.getElementById('tourReviewBox');
                if (bestPathEle !== null && analysisEle !== null && tutorEle != null) {
                    bestPathEle.addEventListener('scroll', that.onBestPathScroll);
                    analysisEle.addEventListener('scroll', that.onAnalysisScroll);
                    tutorEle.addEventListener('scroll', that.onTutorScroll);
                    clearInterval(listenerTimeout);
                }
            }, 500);
        });
    };
    //关闭
    CasePracticeMaxReportComponent.prototype.close = function () {
        var _this = this;
        this.apiService.getOrCreateLearningPath(String(this.learningPathMetaId)).subscribe(function (result) {
            if (_this.isOpenClass == 0) {
                var link = ['case-practice-performance', result.id, 606];
                if (_this.type) {
                    _this.router.navigate(link, { queryParams: { type: 'huatek' } });
                }
                else {
                    _this.router.navigate(link);
                }
            }
        });
    };
    CasePracticeMaxReportComponent.prototype.createAndGetPracticeList = function (exerciseMetaId, userId) {
        return this.apiService.ajax({
            'type': 'GET',
            'url': '/sim/v1/simulation/' + exerciseMetaId + '/createAndGet'
            // 'url': this.commonService.getOrigin()+'/sim/v1/simulation/' + exerciseMetaId +'/createAndGet?userId='+userId
        }).toPromise();
    };
    CasePracticeMaxReportComponent.prototype.onBestPathScroll = function () {
        var overlay = document.getElementById('bestPathBox');
        if (overlay.scrollTop < 1) {
            overlay.scrollTop = 1;
        }
        else if (overlay.scrollHeight - overlay.scrollTop - overlay.clientHeight < 1) {
            overlay.scrollTop = overlay.scrollTop - 1;
        }
    };
    CasePracticeMaxReportComponent.prototype.onAnalysisScroll = function () {
        var overlay = document.getElementById('analysisContent');
        console.log('scroll1');
        if (overlay.scrollTop < 1) {
            overlay.scrollTop = 1;
        }
        else if (overlay.scrollHeight - overlay.scrollTop - overlay.clientHeight < 1) {
            overlay.scrollTop = overlay.scrollTop - 1;
        }
    };
    CasePracticeMaxReportComponent.prototype.onTutorScroll = function () {
        var overlay = document.getElementById('tourReviewBox');
        if (overlay.scrollTop < 1) {
            overlay.scrollTop = 1;
        }
        else if (overlay.scrollHeight - overlay.scrollTop - overlay.clientHeight < 1) {
            overlay.scrollTop = overlay.scrollTop - 1;
        }
    };
    CasePracticeMaxReportComponent.prototype.subWrapOneOut = function () {
        $('#subWrapOne').fadeOut(function () {
            $('#subWrapTwo').fadeIn();
            $('#btnWrap').fadeIn();
        });
    };
    CasePracticeMaxReportComponent.prototype.tourReviewBoxIn = function () {
        console.log($('.closeBtn' + this.skinColor));
        $('#tourReviewShade').fadeIn();
        $('#tourReviewBox').fadeIn();
        $('.closeBtn' + this.skinColor).fadeIn();
        this.pathClickable = false;
    };
    CasePracticeMaxReportComponent.prototype.tourReviewBoxOut = function () {
        $('#tourReviewShade').fadeOut();
        $('#tourReviewBox').fadeOut();
        $('.closeBtn' + this.skinColor).fadeOut();
        this.pathClickable = true;
    };
    CasePracticeMaxReportComponent.prototype.bestPathIn = function () {
        if (!this.pathClickable) {
            return;
        }
        $('.closeBtn' + this.skinColor).fadeIn();
        this.bestPathBoxShow = true;
        $('#shade').fadeIn();
    };
    CasePracticeMaxReportComponent.prototype.bestPathOut = function () {
        $('.closeBtn' + this.skinColor).fadeOut();
        this.bestPathBoxShow = false;
        $('#shade').fadeOut();
    };
    //操作拼接报告
    CasePracticeMaxReportComponent.prototype.handleKaReport = function (userKA, KaAnalysis) {
        var report = [];
        if (userKA.length !== KaAnalysis.length) {
            var id_1 = [];
            for (var i = 0, len = userKA.length; i < len; i += 1) {
                id_1.push(userKA[i].simulationKaId);
            }
            report = KaAnalysis.filter(function (item) { return id_1.indexOf(item.id) > -1; });
            var deselectedItem = this.findDeselectedItem(report, KaAnalysis);
            if (deselectedItem.length) {
                for (var i = 0, len = deselectedItem.length; i < len; i += 1) {
                    userKA.push(deselectedItem[i]);
                }
            }
            else {
                userKA.push(deselectedItem);
            }
        }
        else {
            userKA = userKA;
        }
        console.log(userKA);
        for (var i = 0, len = userKA.length; i < len; i += 1) {
            report[i] = {};
            report[i]['id'] = KaAnalysis[i]['id'];
            report[i]['name'] = KaAnalysis[i]['name'];
            report[i]['value'] = userKA[i]['star'] ? userKA[i]['star'] : 1;
            report[i]['description'] = KaAnalysis[i]['description'];
            report[i]['analysis'] = KaAnalysis[i]['analysis' + report[i]['value']];
        }
        return report;
    };
    // 比对缺少的项
    CasePracticeMaxReportComponent.prototype.findDeselectedItem = function (currentArray, previousArray) {
        for (var i = 0, len = previousArray.length; i < len; i += 1) {
            if (currentArray.indexOf(previousArray[i]) == -1)
                return previousArray[i];
        }
        return null;
    };
    //获取learningTour
    CasePracticeMaxReportComponent.prototype.getLearningTour = function () {
        return this.apiService.ajax({
            'type': 'get',
            'url': '/sr/learningtournew'
        }).toPromise();
    };
    //获取优秀示范
    CasePracticeMaxReportComponent.prototype.getExerciseTutor = function (exerciseMetaId) {
        return this.apiService.ajax({
            'type': 'get',
            'url': '/sr/exerciseTutor/' + this.exerciseMetaId
        }).toPromise();
    };
    //获取KAAnalysis
    CasePracticeMaxReportComponent.prototype.getKAAnalysis = function (exerciseMetaId) {
        return this.apiService.ajax({
            'type': 'get',
            'url': '/sim/v1/simulation/multiExerciseMetas/' + exerciseMetaId + '/getKaAnalysis'
            // 'url': this.commonService.getOrigin() + '/sim/v1/simulation/multiExerciseMetas/' + exerciseMetaId + '/getKaAnalysis'
        }).toPromise();
    };
    //获取learningPathMetaId
    CasePracticeMaxReportComponent.prototype.getLearningPathMetaId = function (learningPathId) {
        return this.apiService.ajax({
            'type': 'get',
            'url': '/ddilearner/v1/getLearningPathMetaId/' + learningPathId
        }).toPromise();
    };
    //重做
    CasePracticeMaxReportComponent.prototype.redo = function () {
        var _this = this;
        if (!this.pathClickable || this.redoClickedStatus) {
            return;
        }
        else {
            this.redoClickedStatus = true;
        }
        var channel = document.getElementById('resource_route');
        var origin = channel.dataset.src === '' ? this.commonService.getOrigin() : 'https://m.transtalent.cn';
        var params = channel.dataset.src === '' ? '' : '&channelHost=' + this.commonService.getOrigin() + '/yyddi/';
        this.createNewCard(this.exerciseMetaId, this.userId).then(function () {
            var originUrl = origin + '/max/' + _this.exerciseMetaId + '/index.html?userId=' + _this.userId + '&learningPathMetaId=' + _this.learningPathMetaId + '&simulationId=' + _this.exerciseMetaId + '&learningPathId=' + _this.practiceList.learningPathId + '&practiceMetaId=' + _this.practiceMetaId + '&token=' + _this.tokenService.findToken() + '&userIdEncoder=' + _this.tokenService.findUserIdEncoder();
            _this.platformLocation['location']['href'] = _this.isOpenClass === 1 ? originUrl + '&isShowBack=0' : _this.type === 'huatek' ? originUrl + '&type=huatek' : originUrl + params;
        });
    };
    //获取KA Star
    CasePracticeMaxReportComponent.prototype.getKAStar = function (cardId) {
        return this.apiService.ajax({
            'type': 'GET',
            'url': '/sim/v1/simulation/card/' + cardId + '/getKaStar'
            // 'url': this.commonService.getOrigin() + '/sim/v1/simulation/card/' + cardId + '/getKaStar'
        }).toPromise();
    };
    //创建新的流水卡
    CasePracticeMaxReportComponent.prototype.createNewCard = function (exerciseMetaId, userId) {
        return this.apiService.ajax({
            'type': 'POST',
            'url': '/sim/v1/simulation/' + exerciseMetaId + '/card'
            // 'url': this.commonService.getOrigin() + '/sim/v1/simulation/' + exerciseMetaId + '/card?userId=' + userId
        }).toPromise();
    };
    CasePracticeMaxReportComponent.prototype.analysisBoxIn = function (i) {
        if (!this.itemClickEnable) {
            return false;
        }
        var _this = this;
        this.currentName = this.report[i].name;
        this.currentDescription = this.report[i].description;
        this.currentTotal = this.report[i].value;
        this.currentAnalysis = this.report[i].analysis;
        $('#analysisShade').fadeIn();
        // 滚动到订端
        $('#analysisContent').scrollTop(0);
        // $('#analysisBox').fadeIn();
        this.analysisBoxShow = true;
        $('body').css('overflow-y', 'hidden');
        setTimeout(function () {
            _this.starShow = true;
        }, 300);
        this.pathClickable = false;
        document.getElementById('analysisShade').ontouchmove = function (e) {
            e.preventDefault();
        };
        document.getElementById('analysisHead').ontouchmove = function (e) {
            e.preventDefault();
        };
        document.getElementById('closeBtn3').ontouchmove = function (e) {
            e.preventDefault();
        };
    };
    CasePracticeMaxReportComponent.prototype.analysisBoxOut = function () {
        $('#analysisShade').fadeOut();
        this.analysisBoxShow = false;
        $('body').css('overflow-y', 'scroll');
        this.starShow = false;
        this.pathClickable = true;
    };
    // 返回列表
    CasePracticeMaxReportComponent.prototype.goToList = function () {
        if (this.goToListClickedStatus) {
            return;
        }
        else {
            this.goToListClickedStatus = true;
        }
        this.close();
    };
    //设置等级参数
    CasePracticeMaxReportComponent.prototype.setPracticeLevelDictionary = function (userKA) {
        console.log(userKA);
        var finalScore = 0;
        userKA.forEach(function (v) {
            v['star'] = v['star'] ? v['star'] : 0;
            finalScore += v['star'];
        }, 0);
        //计算等级
        var level = {
            60602: (finalScore <= 7 && 1) || (finalScore <= 15 && finalScore > 7 && 2) || (finalScore <= 22 && finalScore > 15 && 3) || (finalScore > 22 && 4),
            60603: (finalScore <= 7 && 1) || (finalScore <= 15 && finalScore > 7 && 2) || (finalScore <= 22 && finalScore > 15 && 3) || (finalScore > 22 && 4)
        }[this.exerciseMetaId];
        var description;
        //计算description
        if (this.exerciseMetaId == 60602) {
            description = {
                1: '不错的成绩，你的每一次努力都看得见！',
                2: '为了带领团队达至最佳绩效，你要加油呀！',
                3: '相当优秀，为了完美再试一次吧！',
                4: '大神一般的操作，带领团队达至最佳绩效！'
            }[level] || '错误的等级，无法获取相应的description';
        }
        else if (this.exerciseMetaId == 60603) {
            description = {
                1: '学好绩效管理非一朝一夕之事，继续加油吧！',
                2: '不错的表现，再试一次，突破自我吧！',
                3: '离完美只差一步，再试一次？',
                4: '恭喜你带领团队达至最佳绩效，相当完美的表现！'
            }[level] || '错误的等级，无法获取相应的description';
        }
        return {
            'level': level,
            'description': description
        };
    };
    //进入后测
    CasePracticeMaxReportComponent.prototype.linkToPostSurvey = function () {
        var _this = this;
        this.apiService.getOrCreateLearningPath(this.learningPathMetaId).subscribe(function (result) {
            _this.learningPath = result;
            if (_this.learningPath.subItems.length == 3) {
                _this.getLearningTour().then(function (result) {
                    _this.learningTour = result;
                    var link = ['survey', _this.learningTour.tour_id, 3, 2];
                    _this.router.navigate(link);
                });
            }
            else {
                var link = ['survey', _this.learningPath.id, _this.learningPath.subItems[4].surveyMetaId, 1];
                _this.router.navigate(link);
            }
        });
    };
    return CasePracticeMaxReportComponent;
}());
export { CasePracticeMaxReportComponent };



// WEBPACK FOOTER //
// ./src/app/case-practice-max-report/case-practice-max-report.component.ts.pre-build-optimizer.js